var _excluded = ["classes", "columnHeading", "rows"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import cs from 'classnames';
import PropTypes from 'prop-types';
import TableHead from './table-head/table-head';
import TableBody from './table-body/table-body';
require("./table.css");
var styles = {
  "tableContainer": "tableContainer-3T4nC",
  "table": "table-f-a8c",
  "tableHead": "tableHead-1I1sp",
  "tableColHeader": "tableColHeader-2lgsb",
  "tableColHeaderSticky": "tableColHeaderSticky-311gH",
  "tableBody": "tableBody-1Sc4P",
  "tableRow": "tableRow-1zSWQ",
  "tableRowHeader": "tableRowHeader-boQgE",
  "tableCell": "tableCell-2u8UM"
};
var Table = _ref => {
  var {
      classes,
      columnHeading,
      rows
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var {
    tableHead,
    tableBody,
    tableCell,
    tableColHeader,
    tableRowHeader
  } = classes;
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.tableContainer, classes.tableContainer)
  }, /*#__PURE__*/React.createElement("table", _extends({
    className: cs(styles.table, classes.table)
  }, otherProps), /*#__PURE__*/React.createElement(TableHead, {
    classes: {
      tableHead,
      tableColHeader
    },
    columnHeading: columnHeading
  }), /*#__PURE__*/React.createElement(TableBody, {
    classes: {
      tableBody,
      tableCell,
      tableRowHeader
    },
    rows: rows
  })));
};
Table.defaultProps = {
  classes: {
    table: '',
    tableBody: '',
    tableCell: '',
    tableColHeader: '',
    tableContainer: '',
    tableHead: '',
    tableRow: '',
    tableRowHeader: ''
  }
};
Table.propTypes = {
  /**
    Data to be displayed as columns.
    The value can be either a string or node.
     columnHeading: PropTypes.arrayOf(
      PropTypes.shape({
        isSticky: PropTypes.bool,
        span: PropTypes.number,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      })
    ).isRequired,
  */
  columnHeading: PropTypes.arrayOf(PropTypes.shape({
    isSticky: PropTypes.bool,
    span: PropTypes.number,
    value: PropTypes.node
  })).isRequired,
  /**
    Data to be displayed as rows.
    The value can be either a string or node.
    `isHeading` sets heading styles and can be omitted if using a rowspan.
    The headings are fixed.
     rows: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          isHeading: PropTypes.bool,
          span: PropTypes.number,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        })
      )
    ).isRequired,
   */
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    isHeading: PropTypes.bool,
    span: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  }))).isRequired,
  /** Class Names to overwrite styling */
  classes: PropTypes.shape({
    table: PropTypes.string,
    tableBody: PropTypes.string,
    tableCell: PropTypes.string,
    tableColHeader: PropTypes.string,
    tableContainer: PropTypes.string,
    tableHead: PropTypes.string,
    tableRow: PropTypes.string,
    tableRowHeader: PropTypes.string
  })
};
export default Table;